export enum AskSynclyAnswerType {
  TOPIC_ANALYSIS = 'topic_analysis',
  STATISTICAL_ANALYSIS = 'statistical_analysis',
  PLAIN_TEXT = 'plain_text',
}

export enum QuestionAnswerBlockStatus {
  WAITING = 'waiting',
  REASONING = 'reasoning',
  ANSWERING = 'answering',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum AskMode {
  GENERAL = 'general',
  CONTENT = 'content',
}
